/* Ott-common */
import { AuthType } from '@dtvgo/axios-interceptor-auth';

export default function watchList(backendAxiosInstance) {
  function addToWatchList(assetId) {
    return backendAxiosInstance.put(
      `/experience/v1/watchList/${assetId}`,
      {},
      {
        authType: AuthType.SESSION_TOKEN,
      },
    );
  }

  function removeFromWatchList(assetId) {
    return backendAxiosInstance.delete(
      `/experience/v1/watchList/${assetId}`,
      {
        authType: AuthType.SESSION_TOKEN,
      },
    );
  }

  return {
    addToWatchList,
    removeFromWatchList,
  };
}
